import styled from 'styled-components';
var TitleStyles = styled.h1.withConfig({
  displayName: "Titlestyles__TitleStyles",
  componentId: "pantheon__sc-13efucl-0"
})(["font-size:2.875rem;color:#454545;"]);
export { TitleStyles };